import { Component, ElementRef, HostListener, Inject, PLATFORM_ID, ViewChild, afterNextRender } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { ApiService } from '../services/api.service';
import { CommonModule, formatPercent, isPlatformBrowser } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { RateSearchingComponent } from '../shared/rate-searching/rate-searching.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { FooterComponent } from '../shared/footer/footer.component';

import { Overlay, CloseScrollStrategy } from '@angular/cdk/overlay';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/autocomplete';
import { fromEvent } from 'rxjs';
import { MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VisitorTrackingService } from '../services/visitor-tracking.service';
import { AuthApiService } from 'projects/shared/src/app/service/auth-api.service';
import { ChatbotWidget } from 'projects/shared/src/app/chatbot-widget/chatbot-widget';
import { linerSeoData } from '../tools/constant';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { EventTrackerDirective } from '../shared/event-tracker.directive';

export function scrollFactory(overlay: Overlay): () => CloseScrollStrategy {
  return () => overlay.scrollStrategies.close();
}

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
  standalone: true,
  imports: [CommonModule, MatSidenavModule,
    MatListModule, RouterModule, MatIconModule,
    MatToolbarModule, RouterOutlet, MatMenu,
    MatMenuTrigger, ChatbotWidget , 
    FooterComponent, MatButtonModule, FooterComponent, MatMenuModule, MatRippleModule, MatTooltipModule,
    MatDialogModule, EventTrackerDirective],
  providers: [
    { provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] },
  ]
})
export class NavbarComponent {
  // scroll postion to change navbar background
  @ViewChild('sidecontent') _sideContent!: ElementRef;
  @ViewChild('sidenav') sidenav!: MatSidenav; // Access sidenav instance
  menuList = <any>[
    { name: 'Home', link: '/', isroute: true },
    { name: 'About Us', link: 'about-us', isroute: true },
    { name: 'Services', link: 'service', key: 'service', isroute: false, },
    { name: 'Tools', link: 'tools', key: 'tools', isroute: false, },
    { name: 'Support', link: 'contact-us', isroute: true },
    { name: 'Resources', link: 'resources',  key: 'resources', isroute: false, },
    { name: 'Shipping Liners', link: 'shipping-liners', key: 'shippingLiners', isroute: false, }
  ];

  shippingLinersList = Object.keys(linerSeoData).map(slug => ({
    slug,
    name: linerSeoData[slug].highlightedText,
    logo: linerSeoData[slug].logo,
  }));

  companySubTab = [
    {
      name: 'About us', tb: '-89px', lr: '153px',
      route: 'company/about-us'
    },
    // {
    //   name: 'Careers', tb: '-133px', lr: '153px',
    //   route: ''
    // },
    // {
    //   name: 'Global Presence', icon: 'https://app.atmavaan.com/uploads/Global_Presence_svg_454_2024-04-08_06:28:34.svg',
    //   route: 'main/company/global-presence'
    // },
    // {
    //   name: 'Network with Liner', icon: 'https://app.atmavaan.com/uploads/Network_with_Liner_svg_454_2024-04-08_06:28:28.svg',
    //   route: 'main/company/liner'
    // }
  ];

  toolsSubTab = [
    {
      name: 'Rate Search', tb: '24px', lr: '197px',
      route: 'tools/ocean-freight-rates',
      // img: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Tools/Web/Mask_Group_89.svg',
      icon: 'search',
      width: '12px',
    },
    {
      name: 'Vessel Schedule', tb: '-43px', lr: '153px',
      route: 'tools/vessel-schedules',
      img: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Tools/Web/boat-outline-1.svg',
      width: '16px',
    },
    {
      name: 'Container Tracking', tb: '0px', lr: '153px',
      route: 'tools/tracking-container',
      img: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Home/Web/Container_Tracking_Active.svg',
      width: '16px',
    },
    {
      name: 'Tariff Simulator', tb: '-43px', lr: '153px',
      route: 'tariff-simulator',
      // img: 'https://fonts.gstatic.com/l/font?kit=kJF1BvYX7BgnkSrUwT8OhrdQw4oELdPIeeII9v6oDMzByHX9rA6RzaxHMPdY43zj-jCxv3fzvRNU22ZXGJpEpjC_1v-p_4MrImHCIJIZrDCvHOejddwaz0VAraBymvSX-Td7&skey=b8dc2088854b122f&v=v321',
      icon: 'calculate',
      width: '16px',
    },
    {
      name: 'Tariff Comparison', tb: '-43px', lr: '153px',
      route: 'tariff-comparison',
      // img: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Tools/Web/boat-outline-1.svg',
      icon: 'custom_half_arrows',
      width: '16px',
    },
    {
      name: 'HTS Lookup', tb: '-43px', lr: '153px',
      route: 'hs-code',
      // img: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Tools/Web/boat-outline-1.svg',
      icon: 'manage_search',
      width: '16px',
    }
  ];

  resourceTab = [
    {
      name: 'Blogs', tb: '24px', lr: '197px',
      route: 'resources/blogs',
      // img: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Tools/Web/Mask_Group_89.svg',
      icon: 'search',
      width: '12px',
    }
  ];

  servicesData = {
    primary: [
      {
        title: "Ocean Freight",
        route: "services/ocean-freight-shipping",
        description: "We offer FCL and LCL freight movement with real-time tracking (GPS), integration with carriers, and quick document services.",
        // image: "https://storage.googleapis.com/airlift-images/atmavaan_images/Atmavaan_new_images/Home/Web/primaryservices_oceanfrieght.jpg",
        icon: "directions_boat",
        alt: 'Ocean Ship icon',
        subtitle: [
          {
            name: 'Ocean FCL', tb: '375px', lr: '197px',
            route: 'services/ocean-fcl'
          },
          {
            name: 'Ocean LCL', tb: '329px', lr: '197px',
            route: 'services/ocean-lcl'
          },
          {
            name: 'Air Freight', tb: '284px', lr: '197px',
            route: 'services/air-freight'
          },
          {
            name: 'Trucking Services', tb: '242px', lr: '197px',
            route: 'services/trucking-service'
          }
        ]
      },
      {
        title: "Air Freight",
        route: "services/air-freight",
        description: "We offer time-sensitive, reliable air freight services with quick customs clearance, along with last-mile delivery from India to the USA.",
        // image: "https://storage.googleapis.com/airlift-images/atmavaan_images/Atmavaan_new_images/Home/Web/primaryservices_airfreight.jpg",
        icon: "travel",
        alt: 'Icon'
      },
      {
        title: "Trucking & Warehousing",
        route: "services/trucking-and-warehousing",
        description: "We handle last-mile delivery services from rail or port to the customer’s warehouse, keeping cargo on schedule to avoid costly delays.",
        // image: "https://storage.googleapis.com/airlift-images/atmavaan_images/Atmavaan_new_images/Home/Web/primaryservices_trucking.jpg",
        icon: "local_shipping",
        alt: 'Icon'
      }
    ],
    additional: [
      {
        title: "ISF Filing",
        route: "services/importer-security-filing",
        description: "Atmavaan will handle ISF filing linked to the US customs system on behalf of the Importer of Record.",
        // image: "https://storage.googleapis.com/airlift-images/atmavaan_images/Atmavaan_new_images/Home/Web/additionalservices_isf.jpg",
        icon: "docs",
        alt: 'Icon'
      },
      {
        title: "Customs Clearance",
        route: "services/custom-clearance-services",
        description: "Our trustworthy and capable customs clearing agents will ensure fast and compliant cargo clearance without delays. ",
        // image: "https://storage.googleapis.com/airlift-images/atmavaan_images/Atmavaan_new_images/Home/Web/additionalservices_custom.jpg",
        icon: "task",
        alt: 'Truck Icon'
      },
      {
        title: "Cargo Insurance",
        route: "services/freight-cargo-insurance",
        description: "Atmavaan can arrange cargo insurance through trusted insurance providers. This service will be offered at the time of booking your shipment.",
        // image: "https://storage.googleapis.com/airlift-images/atmavaan_images/Atmavaan_new_images/Home/Web/additionalservices_cargoinsurance.jpg",
        icon: "shield",
        alt: 'Shield Icon'
      }
    ]
  };

  serviceSubTab = [
    {
      title: 'Ocean Freight',
      description: 'Your one-stop destination for ocean freight services.',
      route: 'services/ocean-freight-shipping',
      img: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Home/Web/nav_ocean_freight_icon.png',
      alt: 'Ocean Ship icon',
      subtitle: [
        {
          name: 'Ocean FCL', tb: '375px', lr: '197px',
          route: 'services/ocean-fcl'
        },
        {
          name: 'Ocean LCL', tb: '329px', lr: '197px',
          route: 'services/ocean-lcl'
        },
        {
          name: 'Air Freight', tb: '284px', lr: '197px',
          route: 'services/air-freight'
        },
        {
          name: 'Trucking Services', tb: '242px', lr: '197px',
          route: 'services/trucking-service'
        }
      ]
    },
    {
      title: 'Importer Security Filing',
      description: 'All your ISF needs handled in one place.',
      route: 'services/importer-security-filing',
      img: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Home/Web/nav_isf_icon.png',
      alt: 'Icon',
    },
    {
      title: 'Customs Clearance',
      description: 'Navigate customs clearance with ease.',
      route: 'services/custom-clearance-services',
      img: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Home/Web/nav_customs_clearance_icon.png',
      alt: 'Truck Icon',
    },
    {
      title: 'Cargo Insurance',
      description: 'Secure your shipments with full coverage',
      route: 'services/freight-cargo-insurance',
      img: 'https://storage.googleapis.com/airlift-images/atmavaan_images/Home/Web/nav_cargo_insurance_icon.png',
      alt: 'Shield Icon',
    }
  ];

  companyList: any = [];
  List: any = [];
  showMenus: any = {
    service: false,
    tools: false,
    company: false,
    resources: false,
    shippingLiners: false
  };
  userInfo: any;
  activeSubtab: any;
  selectedCompany: any;
  selectedCompanyId: any;
  isSelected: any;
  routerNavSubcribe: any;
  isFooterNeeded: boolean = true;
  isNavWhiteBgEnable: boolean = false;
  tabName: any;
  scrollValueShown: any;
  isSidenavOpen = false;
  isUserLoggedIn: boolean=false;
  // false on the server (no localStorage there): the login area renders nothing until the browser has checked,
  // so Login / Sign Up never flash next to the user box on page load
  authChecked: boolean = false;
  dialogRef: any;
  authType: any = 'login';

  constructor(private route: Router, private apiService: ApiService,
    private activeRouter: ActivatedRoute, private visitorTrackingService: VisitorTrackingService,
    private authApiService: AuthApiService, private dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object) {
    // Read the login state only after the first render, once hydration has taken over the server HTML.
    // Doing it in ngOnInit made the browser's first render differ from the server's (logged-out) one, and the
    // server-rendered Login / Sign Up links were left behind next to Sign Out.
    afterNextRender(() => this.refreshLoginState());
  }

  ngOnInit() {
    this.authApiService.userChanged.subscribe(() => this.refreshLoginState());

    this.subcribeRoute();
    this.getTabName();
  }

  // login / logout in another tab (e.g. drayage's Logout opening the Atmavaan login page) — keep this tab's
  // navbar in step instead of showing a session that no longer exists
  @HostListener('window:storage', ['$event'])
  onStorageChange(event: StorageEvent) {
    if (event.key === null || event.key === 'x-token' || event.key === 'user') {
      this.refreshLoginState();
    }
  }

  private refreshLoginState() {
    if (isPlatformBrowser(this.platformId)) {
      this.authChecked = true;
      if (!!localStorage.getItem("user")) {
        this.isUserLoggedIn = true;
        this.userInfo = JSON.parse(localStorage.getItem("user") || "{}");
        this.getOrganisation();
      } else {
        this.isUserLoggedIn = false;
        this.userInfo = null;
      }
    }
  }

  ngAfterViewInit() {
    fromEvent(this._sideContent?.nativeElement as HTMLElement, 'scroll').subscribe((e: any) => {
      const num: any = e?.target['scrollTop'];
      if (num > 80)
        this.scrollValueShown = true;
      else
        this.scrollValueShown = false;
    });

    this.activeRouter.fragment.subscribe(fragment => {
      if (fragment) {
        this.apiService.scrollToSection(fragment);
      }
    });

    if (isPlatformBrowser(this.platformId)) {
      this.fixFocusTrapAccessibility();
    }
  }

  private fixFocusTrapAccessibility(): void {
  const anchors = document.querySelectorAll(
    '.cdk-focus-trap-anchor[aria-hidden="true"][tabindex]'
  );
  anchors.forEach(el => el.removeAttribute('tabindex'));
}

  getTabName() {
    const url = this.route.url.split('#')[0];
    const parts = url.split('/');
    this.tabName = parts[parts.length - 1];
  }

  subcribeRoute() {
    this.routerNavSubcribe = this.route.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        const url = event.url.split('#')[0];
        const parts = url.split('/');
        this.tabName = parts[parts.length - 1];
      }
      if (event instanceof NavigationEnd) {
        this.checkFooter();
        const url = event.urlAfterRedirects.split('#')[0];
        const parts = url.split('/');
        this.tabName = parts[parts.length - 1];

        if (isPlatformBrowser(this.platformId) && !event.urlAfterRedirects.includes('#') && this._sideContent) {
          this._sideContent.nativeElement.scrollTo({ top: 0, behavior: 'auto' });
          setTimeout(() => {
            this._sideContent?.nativeElement.scrollTo({ top: 0, behavior: 'auto' });
          }, 150);
        }
      }
    });
    this.checkFooter();
  }

  OnDestroy() {
    if (!!this.routerNavSubcribe) {
      this.routerNavSubcribe.unsubscribe();
    }
  }

  checkFooter() {
    if (isPlatformBrowser(this.platformId)) {
      if (!!location.pathname.includes("discovery/rate-search/")) {
        this.isFooterNeeded = false;
      } else {
        this.isFooterNeeded = true;
      }
    }
  }

  openQuote() {
    // loaded on click so the form stays out of the initial bundle
    import('../contact-form/contact-form.component').then(({ ContactFormComponent }) => {
      this.dialog.open(ContactFormComponent, { width: '560px', maxWidth: '95vw', autoFocus: false });
    });
  }

  signup() {
    this.eventClick('Sign Up', 'Sign up button click in navbar');
    this.localStorageClear();
    let url = "https://app.atmavaan.com/auth/signup";
    // let url = "http://localhost:4209/auth/signup";
    window.open(url, "_self");
  }

  async login() {
    this.eventClick('Login', 'Login button click in navbar');
    this.localStorageClear();
    this.authType = 'login';
    // the login screens are only downloaded when someone actually opens the dialog
    const { LoginDialogComponent } = await import('./login-dialog.component');
    const isMobile = window.innerWidth < 600;
    this.dialogRef = this.dialog.open(LoginDialogComponent, {
      panelClass: 'login-dialog-panel',
      // on phones use most of the screen width instead of the default 80vw, which squeezed the form
      ...(isMobile ? { width: '92vw', maxWidth: '420px' } : {})
    });
    this.dialogRef.afterClosed().subscribe((e: any) => this.loginHandle(e));
  }

  loginHandle(e: any) {
    if (e == 'login_success') {
      let token = localStorage.getItem("x-token");
      let url = "https://app.atmavaan.com/redirect?token=" + encodeURIComponent(token || '') + "&url=main/dashboard";
      // let url = "http://localhost:4209/redirect?token=" + token + "&url=main/dashboard";
      window.open(url, "_self");
    }
  }

  signout() {
    this.localStorageClear();
    this.route.navigate(['auth/login']);
  }

  localStorageClear() {
    localStorage.removeItem('x-token');
    localStorage.removeItem('user');
    localStorage.removeItem('theme');
    localStorage.removeItem('redirectUrl');
  }

  navigatePortal() {
    let token = localStorage.getItem("x-token");
    let url = "https://app.atmavaan.com/redirect?token=" + encodeURIComponent(token || '') + "&url=main/dashboard";
    // let url = "http://localhost:4209/redirect?token=" + token + "&url=main/dashboard";
    window.open(url, "_self");
  }

  getOrganisation() {
    this.apiService.getOrganisation().subscribe(res => {
      if (res.statusCode == 200) {
        this.companyList = res.info;
        this.List = res.info;
        res.info.forEach((i: { id: any; type: string; }) => {
          if (i.id == this.userInfo.refer_id) {
            if (this.userInfo.customer_type == 'lead' || this.userInfo.customer_type == 'Shipper/Consignee' || this.userInfo.customer_type == 'Consignee' || this.userInfo.customer_type == 'Shipper') {
              i.type == 'lead'
            } else if (this.userInfo.type == 'notify_party') {
              i.type == 'notify_party';
            } else if (this.userInfo.type == 'cha') {
              i.type == 'cha';
            }
            this.selectedCompany = i;
            this.selectedCompanyId = i.id;
          }
        });
      }
    })
  }

  updateActiveSubtab(currentSubtab: string): void {
    this.navActionParse(currentSubtab);
    if (currentSubtab) {
      const parts = currentSubtab.split("/");
      this.activeSubtab = parts[0];
      this.tabName = this.activeSubtab;
    }
  }

  handleMenuItemClick(item: any): void {
    this.showMenus[item.key] = !this.showMenus[item.key];
  }

  routePage(list: any) {
    const route = list.route;
    if (route) {
      this.route.navigate([route]);
    }
  }

  navActionParse(currentSubtab: any) {
    let str = '';
    let isCheck = false;

    this.menuList.forEach((item) => {
      if (item.link == currentSubtab) { this.eventClick(item.name, '') }
    });

    if (!isCheck) {
      this.companySubTab.forEach((item) => {
        if (item.route == currentSubtab) { this.eventClick(item.name, '') }
      });
    }

    if (!isCheck) {
      this.toolsSubTab.forEach((item) => {
        if (item.route == currentSubtab) { this.eventClick(item.name, '') }
      });
    }

    if (!isCheck) {
      this.serviceSubTab.forEach((item) => {
        if (item.route == currentSubtab) { this.eventClick(item.title, '') }
      });
    }
  }

  eventClick(action: any, value: string) {
    this.visitorTrackingService.trackEvent({ action: action, type: 'click', value: value, pathname: location.pathname });
  }

  openSupport() {
    let url = "https://wa.me/918925962778?text=Hi Atmavaan,%0a";
    window.open(url, '_blank');
  }

  toggleSidenav() {
    this.sidenav.toggle();
  }

  congetStarted(tab: any) {
    this.route.navigate([tab], { fragment: 'rate' }).then(() => {
      history.replaceState(null, '', this.route.url.split('#')[0]);
      setTimeout(() => {
        this.apiService.scrollToSection('rate');
      }, 10);
    });
  }

  congetStartedMob(tab: any) {
    this.route.navigate([tab], { fragment: 'rate-field' }).then(() => {
      history.replaceState(null, '', this.route.url.split('#')[0]);
      setTimeout(() => {
        this.apiService.scrollToSection('rate-field');
      }, 10);
    });
  }

  homeRoute() {
    this.apiService.setRoute('home');
  }
}